<template>
  <div class="fullpage">
    <div class="searBox">
      <el-input style="width: 300px;" :placeholder="`${$t('menu.LobarHourCode')}/工时名称`" v-model="searchKey"></el-input>
      <el-select v-model="mcSeriesModelId" :placeholder="$t('menu.VehicleModel')" clearable style="margin: 0 10px;">
        <el-option :label="$t('menu.All')" value=" "></el-option>
        <el-option v-for="(item, index) in list" :key="index" :label="item.seriesModel" :value="item.id"></el-option>
      </el-select>
      <el-button type="primary" @click="getList">{{ $t('menu.search') }}</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <div class="table">
      <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="pc" :label="$t('menu.VehicleModel')" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.labourDetail.mcSeriesModelId }}
          </template>
        </el-table-column>
        <el-table-column prop="pc" :label="$t('menu.LobarHourCode')" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.labourDetail.labourId }}
          </template>
        </el-table-column>
        <el-table-column prop="pc" :label="$t('menu.CHDescriptionOfLaborHours')" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.labour.name }}
          </template>
        </el-table-column>
        <el-table-column prop="pc" :label="$t('menu.ENDescriptionOfLaborHours')" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.labour.nameEn }}
          </template>
        </el-table-column>
        <el-table-column prop="pc" :label="$t('menu.StandardLaborHours')" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.labourDetail.labourHours }}
          </template>
        </el-table-column>
        <el-table-column prop="pc" :label="$t('menu.State')" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.labourDetail.status ? $t('menu.InUse') : $t('menu.Deactivated') }}
          </template>
        </el-table-column>
      </el-table>

      <div class="bottompage">
        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage3"
         :page-size="10" layout="total, prev, pager, next"
          :total="totale">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { listMcSeriesModels, pageQueryLabourDetailDtos } from "../../api/api";
export default {
  data () {
    return {
      value: '',
      searchKey: '',
      list: [],
      mation: [],
      currentPage3: 1,
      pagesize: 10,
      totale: 100,
      mcSeriesModelId: '',
    }
  },
  created () {
    this.listMcSeriesModel()
    this.getList()
  },
  methods: {
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.list = res.data;
      // this.formInline.mcSeriesModelId = this.mcSeriesModelId
    },
    getList () {
      let param = 'curPage=' + this.currentPage3 + '&mcSeriesModelId=' + this.mcSeriesModelId + '&pageSize=10&searchKey=' + this.searchKey
      pageQueryLabourDetailDtos(param).then(res => {
        this.mation = res.data.data.list
        this.totale = res.data.data.total
      })
    },
    reset () {
      this.currentPage3 = 1
      this.mcSeriesModelId = ''
      this.searchKey = ''
      this.getListA()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.getList();
    },
  }
}
</script>

<style lang="less" scoped>
.fullpage {
  width: 100%;
  height: 100%;

  .searBox {
    padding-bottom: 30px;
    border-bottom: 1px solid #d7d7d7;
  }

  .table {
    width: 100%;
    padding-top: 15px;

    .bottompage {
      width: 100%;
      text-align: end;
      margin-top: 20px;
    }
  }
}
</style>